
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.44 15.58"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('rect',{staticClass:"cls-1",attrs:{"x":"2.85","y":"13.89","width":"9.87","height":"1.69","rx":".85"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M7.24 12.5h1.09v1.39H7.24zM13.56 12.5H1.88A1.88 1.88 0 0 1 0 10.63V1.88A1.88 1.88 0 0 1 1.88 0h11.68a1.88 1.88 0 0 1 1.88 1.88v8.75a1.88 1.88 0 0 1-1.88 1.87zM1.88 1.09a.79.79 0 0 0-.79.79v8.75a.78.78 0 0 0 .79.78h11.68a.78.78 0 0 0 .78-.78V1.88a.78.78 0 0 0-.78-.79z"}}),_c('path',{attrs:{"fill-rule":"evenodd","fill":"#666","d":"M11.02 6.1V2.27L9.26 6.1h-3.8V2.59L3.72 6.1H1.09v1.09h3.36v1.86l1.3-1.73v-.13h4.26v2.13l1.3-2v-.13h3.03V6.1h-3.32z"}})])])])
          )
        }
      }
    